import { WithClassnames } from '@vertex-protocol/web-common';
import { ROUTES } from 'client/modules/app/consts/routes';
import { DesktopMoreLinksPopover } from 'client/modules/app/navBar/moreLinks/DesktopMoreLinksPopover';
import { MobileMoreLinksCollapsible } from 'client/modules/app/navBar/moreLinks/MobileMoreLinksCollapsible';
import { DesktopNavMarketSwitcher } from 'client/modules/app/navBar/trade/DesktopNavMarketSwitcher/DesktopNavMarketSwitcher';
import { MobileNavTradeCollapsible } from 'client/modules/app/navBar/trade/MobileNavTradeCollapsible';
import { ElementType, ReactNode, useMemo } from 'react';

interface BaseAppNavItem {
  id: string;
}

export interface AppNavLinkItem extends BaseAppNavItem {
  type: 'link';
  href: string;
  // Used in conjunction with `pathname` to conditionally identify a selected route.
  basePath: string;
  label: ReactNode;
  disabled?: boolean;
}

export interface AppNavCustomItem extends BaseAppNavItem {
  type: 'custom';
  content: {
    Desktop: ElementType;
    Mobile: ElementType<WithClassnames>;
  };
}

export type AppNavItem = AppNavLinkItem | AppNavCustomItem;

export function useAppNavItems() {
  return useMemo(
    () =>
      [
        {
          id: 'perpetuals',
          type: 'link',
          href: `${ROUTES.perpTrading}?market=XAUTUSDT0`,
          label: 'Perpetuals',
          basePath: ROUTES.perpTrading,
        },
        {
          id: 'portfolio',
          type: 'link',
          href: ROUTES.portfolio.overview,
          label: 'Portfolio',
          basePath: ROUTES.portfolio.base,
        },
        {
          id: 'markets',
          type: 'link',
          href: ROUTES.markets,
          label: 'Markets',
          basePath: ROUTES.markets,
        },
        {
          id: 'trade',
          type: 'custom',
          content: {
            Desktop: DesktopNavMarketSwitcher,
            Mobile: MobileNavTradeCollapsible,
          },
        },
        {
          id: 'more',
          type: 'custom',
          content: {
            Desktop: DesktopMoreLinksPopover,
            Mobile: MobileMoreLinksCollapsible,
          },
        },
      ] as AppNavItem[],
    [],
  );
}
